import React, { useState, useEffect, useRef } from "react";

import {
  Card,
  CardBody,
  Col,
  Row,
  CardTitle,
  Alert,
  Label,
  Button,
  Modal,
  ModalBody
} from "reactstrap";

import { AvForm, AvField, AvInput, AvRadioGroup, AvRadio, AvGroup, AvFeedback } from "availity-reactstrap-validation";
import { post, put, get } from '../../helpers/api_helper';
import Utils from '../Utility';
import { toast } from "react-toastify";
import AddUserForm from "./AddUserForm";
import Multiselect from 'multiselect-react-dropdown';
import SearchableDropdown from '../../components/SearchableDropDown';
import stateJson from '../../assets/jsons/state.json';
import cityJson from '../../assets/jsons/city.json';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';


const AddProjectForm = (props) => {
  const { user, data, role, loading, setLoading } = props;
  const [successMsg, setSuccessMsg] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [desc, setDesc] = useState("");
  const [descContent, setDescContent] = useState(null);
  const [locations, setLocations] = useState([]);
  const [isLocationInput, setIsLocationInput] = useState(true);
  const [stateOptions, setStateOptions] = useState([]);
  const [state, setState] = useState("");
  const [isStateError, setIsStateError] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const [city, setCity] = useState("");
  const [isCityError, setIsCityError] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [courses, setCourses] = useState([]);
  const [qualis, setQualis] = useState([]);
  const [selectedQuali, setSelectedQuali] = useState([]);
  const [industry, setIndustry] = useState([]);

  useEffect(() => {
    if (user) {
      if (data?.location.length > 0) {
        setLocations(data?.location);
        setIsLocationInput(false);
      }
      if (typeof data?.qualiId=='object' && data?.qualiId.length > 0) {
        setSelectedQuali(data?.qualiId);
      }
      let stat = [];
      stateJson.map((s, index) => {
        if (s.countryCode == "IN")
          stat.push({ id: index, name: s.name });
      });
      stat.sort((a, b) => {
        if (a.name > b.name)
          return 1;
        if (a.name < b.name)
          return -1;
        return 0;
      });
      setStateOptions(stat);
      getMetas();
      if (data?.desc) {
        const contentBlock = htmlToDraft(data?.desc);
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
          const editorState = EditorState.createWithContent(contentState);
          setDescContent(editorState);
          setDesc(data?.desc);
        }
      }
    }
  }, [user, data]);

  useEffect(() => {
    if (state) {
      let cit = [];
      const foundStatObj = stateJson.find(x => x.name == state);
      console.log('chaning state', foundStatObj);
      cityJson.map((c, index) => {
        if (c.stateCode == foundStatObj.isoCode)
          cit.push({ id: index, name: c.name });
      });
      cit.sort((a, b) => {
        if (a.name > b.name)
          return 1;
        if (a.name < b.name)
          return -1;
        return 0;
      });
      setCityOptions(cit);
      setIsStateError(false);
    } else {
      setCityOptions([]);
    }
  }, [state]);

  const getMetas = () => {
    get("/comp/list", { token: user?.token })
      .then(json => {
        if (json?.statusCode == 200) {
          setCompanies(json?.data);
        }
      })
      .catch(error => {
        console.log('error while getting project list', error);
      });
    get("/meta/list", { token: user?.token })
      .then(json => {
        if (json?.statusCode == 200) {
          setCourses(json?.data?.courses);
          setQualis(json?.data.qualis);
          setIndustry(json?.data.departs);
        }
      })
      .catch(error => {
        console.log('error while getting project list', error);
      })
  }

  function handleValidSubmit(event, values) {
    console.log('values from form', values);
    if (user) {
      if (data?._id) {
        //updating user
        let isNAPS = false;
        if (values.isNAPS == 'yes')
          isNAPS = true;
        if (locations.length < 1) {
          setIsCityError(true);
          setIsStateError(true);
          return;
        }
        const body = {
          ...values,
          isNAPS,
          desc,
          duration: values?.duration ? values?.duration + " " : "" + values?.durationType ? values?.durationType : "",
          location: locations,
          opporId: data?._id,
          addedBy: user?._id,
          qualiId: selectedQuali,
          token: user?.token,
        };
        setLoading(true);
        let url = "/oppor/update";
        put(url, body)
          .then((json) => {
            console.log('response from updating user', json);
            setLoading(false);
            if (json.statusCode == 200) {
              console.log('oppor added')
              setSuccessMsg(json?.message);
              toast.success(json?.message);
              setErrorMsg(null);
              props.close(false);
            } else {
              setErrorMsg(json?.error);
              toast.error(json?.error);
              setSuccessMsg(null);
            }
          })
          .catch(error => {
            console.error('error while adding oppor', error);
            setErrorMsg('Something Went Wrong!');
            toast.error(JSON.stringify(error));
            setSuccessMsg(null);
            setLoading(false);
          });
      } else {
        //adding new user
        let isNAPS = false;
        if (values.isNAPS == 'yes')
          isNAPS = true;
        if (locations.length < 1) {
          setIsCityError(true);
          setIsStateError(true);
          return;
        }
        const body = {
          ...values,
          isNAPS,
          desc,
          duration: values?.duration + " " + values?.durationType,
          location: locations,
          qualiId: selectedQuali,
          addedBy: user?._id,
          token: user?.token,
        };
        let url = "/oppor/add";
        setLoading(true);
        post(url, body)
          .then((json) => {
            console.log('response from adding oppor', json);
            setLoading(false);
            if (json.statusCode == 200) {
              console.log('oppor added')
              setSuccessMsg(json?.message);
              toast.success(json?.message);
              setErrorMsg(null);
              props.close(false);
            } else {
              setErrorMsg(json?.error);
              toast.error(json?.error);
              setSuccessMsg(null);
            }
          })
          .catch(error => {
            console.error('error while adding oppor', error);
            setErrorMsg('Something Went Wrong!');
            toast.error(JSON.stringify(error));
            setSuccessMsg(null);
            setLoading(false);
          })
      }
    }
  }

  const addLocation = () => {
    if (state) {
      if (city) {
        const found = locations.findIndex(x => x.city == city);
        if (found == -1) {
          let temp = Object.assign([], locations);
          temp.push({ city, state });
          setCity("");
          setState("");
          setLocations(temp);
          setIsLocationInput(false);
        } else
          toast.error(`This 'City' already added, try a new one!`);
      } else {
        setIsCityError(true);
      }
    } else
      setIsStateError(true);
  }

  const removeLocation = (index) => {
    let temp = Object.assign([], locations);
    temp.splice(index, 1);
    setLocations(temp);
    if (temp.length < 1)
      setIsLocationInput(true);
    // setFiles(temp);
  }

  const onEditorStateChange = (editorState) => {
    const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setDesc(html);
    setDescContent(editorState);
  }

  const selectQuali = async (item) => {
    console.log('on change quali', item);
    if (item == "")
      return;
    let selQual = Object.assign([], selectedQuali);
    let found = selQual.findIndex(x => x?._id == item)
    if (found == -1) {
      selQual.push(item)
      setSelectedQuali(selQual);
    }
  }

  const removeQuali = (index) => {
    let temp = Object.assign([], selectedQuali);
    temp.splice(index, 1);
    setSelectedQuali(temp);
  }

  return (
    <React.Fragment>
      <div className="">
        <Row>
          <Col>
            {errorMsg &&
              <Alert color="danger">{errorMsg}</Alert>
            }
            {successMsg &&
              <Alert color="success">{successMsg}</Alert>
            }
            <Card>
              <CardBody>
                <div className="">
                  <div className="d-flex" style={{ marginLeft: 'auto' }}>
                    <div>
                      <CardTitle className="h4">{data?._id ? 'Update' : 'Add New'} {props.role}</CardTitle>
                      <p className="card-title-desc">
                        This <code>{props.role}</code> will be {data?._id ? 'updated' : 'added'} to your company.
                      </p>
                    </div>
                    <div className="text-center" style={{ marginLeft: 'auto' }}>
                      <Button color="primary" onClick={() => { props.setCurrentUser(null); props?.close(false); if (props?.from == 'detail') props?.setIsTable(false); }} style={{ backgroundColor: Utils.themeColor }}>
                        Close
                      </Button>
                    </div>
                  </div>
                  <AvForm
                    className="form-horizontal"
                    onValidSubmit={(e, v) => {
                      handleValidSubmit(e, v)
                    }}
                  >
                    <Row>
                      <Col xl={4}>
                        <div className="form-group mb-4">
                          <AvField
                            name="title"
                            label={props.role + " Title"}
                            value={data?.title}
                            className="form-control"
                            placeholder={`Enter Title`}
                            type="text"
                            required
                          />
                        </div>
                      </Col>
                      <Col xl={4}>
                        <div className="form-group mb-4">
                          <Row>
                            <Col md={8}>
                              <AvField
                                name="duration"
                                label={"Duration"}
                                value={data?.duration}
                                className="form-control"
                                placeholder={`Enter Duration ei. 3 months`}
                                type="number"
                              />
                            </Col>
                            <Col md={4}>
                              <AvField
                                name="durationType"
                                label={"Duration Type"}
                                value={data?.durationType}
                                className="form-control"
                                // placeholder={`Enter Duration ei. 3 months`}
                                type="select"
                              >
                                <option value={null} >Select Duration Type</option>
                                <option value={'Days'} >Day</option>
                                <option value={"Weeks"} >Week</option>
                                <option value={"Months"} >Month</option>
                                <option value={"Years"} >Year</option>
                              </AvField>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                      <Col xl={4}>
                        <div className="form-group mb-4">
                          <AvField
                            name="companyId"
                            label={"Company"}
                            value={data?.companyId}
                            className="form-control"
                            type="select"
                            required
                          >
                            <option value={null}>Select Company</option>
                            {companies.map(item => {
                              return (
                                <option value={item?._id}>{item.title}</option>
                              )
                            })}
                          </AvField>
                        </div>
                      </Col>
                    </Row>
                    <span style={{}}>Locations</span>
                    <div className="d-flex" style={{ marginBottom: 20, marginTop: 10 }}>
                      {locations.map((item, index) => {
                        return (
                          // <div style={{ display: 'grid', justifyItems: 'center', marginLeft: 20 }}>
                          //   <i className="mdi mdi-close" style={{
                          //     fontSize: 18, backgroundColor: Utils.themeColor,
                          //     padding: '0px 5px', color: 'white', borderRadius: 22, cursor: 'pointer',
                          //     marginRight: -40, marginBottom: -25, zIndex: 9
                          //   }}
                          //     onClick={() => removeFile(index)}
                          //   />
                          <div className="d-flex" style={{ border: '1px solid ' + Utils.themeColor, alignSelf: 'center', marginLeft: 20 }}>
                            <span style={{ padding: '5px 5px' }}>{item.city}, {item.state}</span>
                            <span style={{
                              backgroundColor: Utils.themeColor, marginLeft: 10,
                              padding: '5px 10px', color: 'white', cursor: 'pointer'
                            }}
                              onClick={() => removeLocation(index)}
                            >X</span>
                          </div>
                        )
                      })}
                      {locations.length > 0 &&
                        <div style={{ alignSelf: 'center', marginLeft: 20 }}>
                          <Button color="primary" onClick={() => setIsLocationInput(true)} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor }}>
                            + Add More
                          </Button>
                        </div>
                      }
                    </div>
                    {isLocationInput &&
                      <div className="d-flex">
                        <div className="form-group mb-4">
                          <SearchableDropdown
                            options={stateOptions}
                            label="name"
                            name="State"
                            id="id"
                            placeholder={"Select State"}
                            selectedVal={state}
                            handleChange={(val) => setState(val)}
                            isError={isStateError}
                          />
                        </div>
                        <div className="form-group mb-4" style={{ marginLeft: 20 }}>
                          <SearchableDropdown
                            options={cityOptions}
                            label="name"
                            name="City"
                            id="id"
                            placeholder={"Select City"}
                            selectedVal={city}
                            handleChange={(val) => { setIsCityError(false); setCity(val) }}
                            isError={isCityError}
                          />
                        </div>
                        <div style={{ alignSelf: 'center', marginLeft: 20 }}>
                          <Button color="primary" onClick={() => addLocation()} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor }}>
                            Add Location
                          </Button>
                        </div>
                        <div style={{ alignSelf: 'center', marginLeft: 20 }}>
                          <Button color="primary" onClick={() => { setCity(""); setState(""); setIsLocationInput(false) }} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor }}>
                            Cancel
                          </Button>
                        </div>
                      </div>
                    }
                    <Row>
                      <Col md={4}>
                        <div className="form-group mb-4">
                          <AvField
                            name="qualiId"
                            label={"Minimum Qualification"}
                            value={data?.qualiId}
                            className="form-control"
                            type="select"
                            required
                            onChange={(e) => selectQuali(e.target.value)}
                          >
                            <option value={""}>Select Min Qualification</option>
                            {qualis.map(item => {
                              return (
                                <option value={item?._id}>{item.title}</option>
                              )
                            })}
                          </AvField>
                          <div className="d-flex" style={{ flexWrap: 'wrap' }}>
                            {selectedQuali?.map((item, index) => (
                              <div className="d-flex" style={{ border: '1px solid ' + Utils.themeColor, alignSelf: 'center', alignItems: 'center', marginLeft: 20, marginTop: 10 }}>
                                <span style={{ padding: '5px 5px' }}>{qualis.find(x => x?._id == item)?.title}</span>
                                <span style={{
                                  backgroundColor: Utils.themeColor, marginLeft: 10,
                                  padding: '5px 10px', color: 'white', cursor: 'pointer'
                                }}
                                  onClick={() => removeQuali(index)}
                                >X</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="form-group mb-4">
                          <AvField
                            name="opporFor"
                            label={"Opportunity For"}
                            value={data?.opporFor}
                            className="form-control"
                            type="select"
                            required
                          >
                            <option value={""}>Select Gender</option>
                            <option value={"Male"}>Male</option>
                            <option value={"Female"}>Female</option>
                            <option value={"Male & Female"}>Male & Female</option>
                            <option value={"Transgender"}>Transgender</option>
                            <option value={"Physically Disabled"}>Physically Disabled</option>
                          </AvField>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="form-group mb-4">
                          <AvField
                            name="industryId"
                            label={"Industry"}
                            value={data?.industryId}
                            className="form-control"
                            type="select"
                            required
                          >
                            <option value={null}>Select Industry</option>
                            {industry.map(item => {
                              return (
                                <option value={item?._id}>{item.title}</option>
                              )
                            })}
                          </AvField>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="form-group mb-4">
                          <AvField
                            name="courseId"
                            label={"Course"}
                            value={data?.courseId}
                            className="form-control"
                            type="select"
                            required
                          >
                            <option value={null}>Select Course</option>
                            {courses.map(item => {
                              return (
                                <option value={item?._id}>{item.title}</option>
                              )
                            })}
                          </AvField>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <div className="form-group mb-4">
                          <AvField
                            name="vacancy"
                            label={"No of vacancies"}
                            value={data?.vacancy}
                            className="form-control"
                            placeholder={`Enter vacancies`}
                            type="number"
                            required
                            validate={{ min: { value: 1 } }}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <div className="form-group mb-4">
                        </div>
                        <Editor
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          onEditorStateChange={onEditorStateChange}
                          editorState={descContent}
                        />
                      </Col>
                    </Row>
                    {/* <AvField name="idx" value={user?.company._id} type="hidden" /> */}
                    <div className="text-center mt-4">
                      {data?._id ?
                        <Button type="submit" color="primary" style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor }}>
                          Update {props.role}
                        </Button>
                        :
                        <Button type="submit" color="primary" style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor }}>
                          Add {props.role}
                        </Button>
                      }
                    </div>
                  </AvForm>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div >
    </React.Fragment >
  )
}

export default AddProjectForm;
